import { configureStore } from '@reduxjs/toolkit';
import promise from "redux-promise-middleware";
import reducers from "../reducers";

export default configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(promise),
});